export enum StorageKey {
  THEME_MODE = 'celeri.theme.mode',
  ACCESS_TOKEN = 'celeri.session.token',
  DEVICE_ID = 'celeri.session.device-id',
  LANGUAGE = 'celeri.i18n.language',
  NPS_SUBMITTED_AT = 'celeri.support.nps-submitted-at',
  SELECTED_PROJECT = 'celeri.projects.selected',
}

export const SESSION_SCOPED_KEYS: readonly StorageKey[] = [StorageKey.ACCESS_TOKEN];
